// Required UK company disclosure for CrewZ Rowing Technology Limited.
// Renders a small, unobtrusive line at the bottom of public-facing screens.

const YEAR = new Date().getFullYear();

export default function CompanyFooter({ className = '' }) {
  return (
    <footer
      className={`text-[11px] leading-relaxed text-zinc-400 dark:text-zinc-500 text-center px-4 py-4 ${className}`}
      data-testid="company-footer"
    >
      <p className="font-medium">
        © {YEAR} CrewZ Rowing Technology Limited
      </p>
      <p>
        Registered in England and Wales · Company No.{' '}
        <span className="font-mono tabular-nums">17180291</span>
      </p>
    </footer>
  );
}
